import {ModelRepository} from 'b302-frontend-library';
import Region from "../models/Region";

class RegionRepository extends ModelRepository<Region> {

    public constructor() {
        super('/continents');
    }
}

export default RegionRepository;
